export default ({ data }) => {
  return {
    table: data.table,
    footnote: data.footnote,
  };
};
